import product from './product.js';

/**
 * Products list
 * Generating productList with product
 * @param {object} cart Cart data object
 * @param {Array} products Products array
 * @param {string} code List code name
 * @returns {object} Product list object
 */
export default (cart, products, code) => {
	const productsList = {
		code,
		products: []
	};
	// Check if is array and is not empty
	if (Array.isArray(products) && products.length) {
		products.forEach((productData) => {
			productsList.products.push(product(productData, cart.order));
		});
	}
	return productsList;
};
